import { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import dayjs from 'dayjs';
import moment from 'moment';

import { CardContent, Modal } from '@mui/material';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import MenuItem from '@mui/material/MenuItem';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { getEquipmentPartsByQueryString, patchEquipmentParts } from 'components/axios/equipmentAxios';
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import AvgLifeTime from 'components/AvgLifeTime';
import CustomDatePicker2 from 'components/date_picker/CustomDatePicker2';
import { useTranslation } from 'react-i18next';

const EquipmentPartsReplaceLayer = ({info, type, setIsLoading:setParentIsLoading}) => {
    const { t } = useTranslation();
    const { role } = useEnumApi();
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => setOpen(false);

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };
    
    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const todayTimestamp = Date.now();
    const [equipmentParts, setEquipmentParts] = useState([]);
    const [instlAts , setInstlAts] = useState([]);
    const [inspections , setInspections] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const inspectionCycleList = () => {
      // console.log(isLoading);
      let query = {"equipment.id": info.id, "deletedYn" : "false", lifeSpanTime: "ne(0)", size:50};
      let queryString = Object.entries(query).map(([key, value]) => ( value && key+'='+value)).filter(v=>v).join('&');
      queryString += "&sort=masterEquipmentPart.equipmentCtgr.name,asc&sort=position,asc&sort=masterEquipmentPart.name,asc";
      // console.log(queryString)
      getEquipmentPartsByQueryString("?"+queryString).then((data)=>{
        if (data && data._embedded) {
          const list = data._embedded.equipmentParts;
        //   console.log(list);

          let parts = [];
          let instlAts = [];
          list.map(function(item, i) {
            parts.push({id:item.id, position:item.position, instlAt:item.instlAt, lifeSpanTime:item.lifeSpanTime
              , masterEquipmentPartId:item.masterEquipmentPart.id
              , masterEquipmentPartLifeSpanTime:item.masterEquipmentPart.lifeSpanTime
              , masterEquipmentPartEquipmentCtgrName:item.masterEquipmentPart.equipmentCtgr.name
              , masterEquipmentPartName : item.masterEquipmentPart.name
              , masterEquipmentPartEquipmentCtgrNameAndPosition:item.masterEquipmentPart.equipmentCtgr.name+"-"+item.position
            })
            instlAts.push({id:item.id, instlAt:item.instlAt});
          }) 
          // console.log(parts);
          // console.log(instlAts);
          // setEquipmentPartList(parts);
          setInstlAts(instlAts);


          const result2 = parts.reduce((acc, curr) => { 
            const { masterEquipmentPartEquipmentCtgrNameAndPosition } = curr;
            if (acc[masterEquipmentPartEquipmentCtgrNameAndPosition]) acc[masterEquipmentPartEquipmentCtgrNameAndPosition].push(curr);
            else acc[masterEquipmentPartEquipmentCtgrNameAndPosition] = [curr];
            return acc;
          }, {}); 

          //console.log(result2);
          //console.log(Object.values(result2));

          setEquipmentParts(Object.values(result2));
          setIsLoading(true);
        }
      })
    }

    useEffect(()=>{
    //   console.log(isLoading);
      if (info && !isLoading) {
        setTimeout(()=>{
            inspectionCycleList();
        }, 1000)
      //  repairList();
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info, isLoading]);

    const [btnClass, setBtnClass] = useState();
    const [btnTitle, setBtnTitle] = useState();
    useEffect(() => {
      if (type === 'NORMAL') {
        setBtnClass("instate1");
        setBtnTitle(t('message.common.text.available'));
      } else if (type === 'ALERT') {
        setBtnClass("instate2");
        setBtnTitle(t('message.common.text.imminent'));
      } else if (type === 'EXPIRED') {
        setBtnClass("instate3");
        setBtnTitle(t('message.common.text.lapse'));
      }
    }, [type]);

    const modifyClick = (id) => {
      let param = null;
      if (instlAts.map(temp=>temp.id).includes(id)) {
        param = instlAts.filter(temp=>temp.id === id)[0];
      }
// console.log(param)
      if (param) {
        if (param.instlAt == null || param.instlAt == '' || param.instlAt == 'Invalid date') {
          alertMessage = t('message.common.alert.recent.replacement.date.input');
          setAlertMessage(alertMessage);
          handleAlertClick();
          return;
        }
        openModal(modals.confirmModal, {
          onSubmit: (value) => {
            patchEquipmentParts(param).then((res)=> {
              alertMessage = t('message.common.alert.modify.done');
              setAlertMessage(alertMessage);
              handleAlertClick();
            })
            setIsLoading(false);
            setParentIsLoading(false);
          },
          onClose: () => {
            console.log('close');
          },
          message: t('message.common.alert.modify.question'),
        });
      } else {
        alertMessage = t('message.common.alert.recent.replacement.date.select');
        setAlertMessage(alertMessage);
        handleAlertClick();
      }
    }

    const applyClick = (id) => {
      let body = null;
      if (inspections.map(temp=>temp.partId).includes(id)) {
        body = inspections.filter(temp=>temp.partId === id)[0];
      }
      // console.log(body)
      let param = null;
      if (body) {
        param = {id:body.partId, lifeSpanTime:(body.cycle*30*24)}
      }
      // console.log(param)
      if (param) {
        openModal(modals.confirmModal, {
          onSubmit: (value) => {
            patchEquipmentParts(param).then((res)=> {
              //console.log('modify ' ,res);
              alertMessage = t('message.common.alert.apply');
              setAlertMessage(alertMessage);
              handleAlertClick();
            })
            setIsLoading(false);
            setParentIsLoading(false);
          },
          onClose: () => {
            console.log('close');
          },
          message: t('message.common.alert.apply.question'),
        });
      } else {
        alertMessage = t('message.common.alert.self.management.cycle.select');
        setAlertMessage(alertMessage);
        handleAlertClick();
      }
    }

    return (
        <>
        {/* <Button variant="contained" > */}
        <span className={btnClass} onClick={handleOpen} style={{padding:"3px", minWidth:"unset", cursor:"pointer"}}>{btnTitle}</span>
        {/* </Button> */}

        <Modal className="pop_box pop_box4" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <MainCard modal darkTitle content={false} style={{padding:"10px", minWidth : "800px", minHeight : "300px"}}>
              <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                <div>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.replacement.inspection.cycle.arrival.rate')} color="primary" style={{maxWidth:"400px"}}/>
                </div>

                <div>
                  <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                    {t('message.common.btn.close')}
                  </Button>
                </div>
              </div>
  
              <CardContent>
                <div>
                    <Row className='maint_tabs_cont'>
                        <Col /*sm={8}*/ style={{padding:"10px"}}>
                            {equipmentParts &&
                            <TableContainer>
                            <Table sx={{ minWidth: 900 }} aria-label="simple table">
                                <TableHead>
                                <TableRow>
                                    <TableCell className="th" align="center" style={{width:"18%"}}>{t('message.common.subtitle.level2')}</TableCell>
                                    <TableCell className="th" align="center" style={{width:"10%"}}>{t('message.common.subtitle.location')}</TableCell>
                                    <TableCell className="th" align="center" style={{width:"10%"}}>{t('message.common.subtitle.material')}</TableCell>
                                    <TableCell className="th" align="center" style={{width:"22%"}}>{t('message.common.subtitle.self.management.cycle')}</TableCell>
                                    <TableCell className="th" align="center" style={{width:"8%"}}>{t('message.common.subtitle.peer.average')}</TableCell>
                                    <TableCell className="th" align="center" style={{width:"9%"}}>{t('message.common.subtitle.replacement.expect.date')}<br/>({t('message.common.subtitle.recent.replacement.date')})</TableCell>
                                    { role !== ROLE.MO.code && <TableCell className="th no-print-page" align="center" style={{width:"24%"}}>{t('message.common.subtitle.inspection')}</TableCell> }
                                </TableRow>
                                </TableHead>
                                <TableBody>
                            {equipmentParts && equipmentParts.map(function(items, ids) {
                                // console.log(items)
                                return (
                                items.map(function(item, i) {
                                    // console.log(item)
                                let recommendTime = dayjs(new Date(item.instlAt)).add((item.masterEquipmentPartLifeSpanTime/30/24), "M").valueOf();
                                let instlTime = (new Date(item.instlAt)).getTime();
                                let rate = Math.round(((todayTimestamp - instlTime)/(recommendTime - instlTime)) * 100);
                                let colorClass = "";
                                if (rate > 100) {
                                    colorClass = "red";
                                }
                                let basicLifeSpan = item.masterEquipmentPartLifeSpanTime/30/24;
                                let lifeSpan = item.lifeSpanTime/30/24;
                                let viewLifeSpan = basicLifeSpan;
                                if (basicLifeSpan < lifeSpan) {
                                    viewLifeSpan += "+"+(lifeSpan-basicLifeSpan);
                                }
                                let viewUseLiftSpan = parseInt((todayTimestamp - instlTime)/30/24/1000/60/60)
                                return (
                                <TableRow key={i}>
                                    {i===0 && <TableCell className='td_print' align="center" rowSpan={items.length}>{(item.masterEquipmentPartEquipmentCtgrName) || ''}</TableCell>}
                                    {i===0 && <TableCell className='td_print' align="center" rowSpan={items.length}>{(item.position) || ''}</TableCell>}
                                    <TableCell className='td_print' align="center">{(item.masterEquipmentPartName) || ''}</TableCell>
                                    <TableCell className='td_print' style={{textAlign:"left"}}>
                                        <div style={{position:"relative"}}>
                                            <div style={{color:"#FFF",float:"left",position:"absolute",left:"10px"}}>{viewUseLiftSpan}{t('message.common.text.month')}</div>
                                            <div className="percent">
                                                <p><span className={colorClass} style={{width:`${rate > 100 ? 100:rate}%`}}></span></p>
                                                <span className="percent_month">{viewLifeSpan}{t('message.common.text.month')}</span>
                                            </div>
                                        </div>                          
                                    </TableCell>
                                    <TableCell className='td_print' align="center"><AvgLifeTime masterEquipmentPartId={item.masterEquipmentPartId} position={item.position} useLife={(todayTimestamp - instlTime)}/></TableCell>
                                    <TableCell className='td_print' align="center">
                                    {dayjs(new Date(item.instlAt)).add(lifeSpan, "M").format("YYYY-MM-DD")}<br/>
                                    { role === ROLE.MO.code ?
                                    dayjs(new Date(item.instlAt)).format("YYYY-MM-DD") :
                                    <div style={{display:"flex"}}>
                                        <FormControl sx={{ m: 1, minWidth: 110 }}>
                                        <CustomDatePicker2 
                                            // labelName={'최근교체일'}
                                            name={`instlAt_${item.id}`}
                                            defaultValue={dayjs(instlAts.filter(temp=>temp.id===item.id)[0].instlAt).format("YYYY-MM-DD")} 
                                            onChange={(e)=>{
                                            // console.log(e)
                                            let instlAt = e.target.value;
                                            // console.log(instlAt);
                                            if (instlAt != null && instlAt != '' && instlAt.split("-").length == 3 && regexDate.test(instlAt)) {
                                                let instlAtCopys = [...instlAts];
                                                //let instlAt = dayjs(e).format("YYYY-MM-DD");
                                                instlAt = moment(new Date(parseInt((instlAt.split("-"))[0]), parseInt((instlAt.split("-"))[1]) - 1, parseInt((instlAt.split("-"))[2]), 0, 0, 0)).format()
                                                // const instlAt = moment(new Date(parseInt((e.instlAt.split("-"))[0]), parseInt((e.instlAt.split("-"))[1]) - 1, parseInt((e.instlAt.split("-"))[2]), 0, 0, 0)).format()
                                                // console.log(instlAt)
                                                if (instlAtCopys.map(temp=>temp.id).includes(item.id))
                                                instlAtCopys.filter(temp=>temp.id===item.id)[0].instlAt = instlAt;
                                                // console.log(instlAtCopys)
                                                setInstlAts(instlAtCopys)
                                            } else {
                                                let instlAtCopys = [...instlAts];
                                                if (instlAtCopys.map(temp=>temp.id).includes(item.id))
                                                instlAtCopys.filter(temp=>temp.id===item.id)[0].instlAt = null;
                                                setInstlAts(instlAtCopys)
                                            }
                                            }}
                                        />
                                        </FormControl>
                                        <Button className="apply_btn" variant="contained" style={{height:"fit-content", top:"10px"}} onClick={()=>{modifyClick(item.id)}}>{t('message.common.btn.modify')}</Button>
                                    </div>
                                    }
                                    </TableCell>
                                    { role !== ROLE.MO.code &&
                                    <TableCell align="center" className='no-print-page'>
                                    <div className="apply">
                                        <FormControl sx={{ m: 1, minWidth: 100 }}>
                                        <Select key={item.id} 
                                            name={"cycle_"+item.id} 
                                            defaultValue={''} id="grouped-select" 
                                            onChange={(e)=>{
                                            let inspectionCopys = [...inspections];
                                            if (inspectionCopys.map(temp=>temp.partId).includes(item.id))
                                                inspectionCopys.filter(temp=>temp.partId===item.id)[0].cycle = e.target.value;
                                            else
                                                inspectionCopys.push({partId : item.id, cycle : e.target.value});
                                            setInspections(inspectionCopys)
                                            }}>
                                            <MenuItem disabled sx={{display : 'none'}} key="empty" value={''}><em>None</em></MenuItem>
                                            {/* <MenuItem key={-1} value={-1}>교체</MenuItem> */}
                                            <MenuItem key={3+(item.lifeSpanTime/30/24)} value={3+(item.lifeSpanTime/30/24)}>3{t('message.common.select.month.extension')}</MenuItem>
                                            <MenuItem key={6+(item.lifeSpanTime/30/24)} value={6+(item.lifeSpanTime/30/24)}>6{t('message.common.select.month.extension')}</MenuItem>
                                            <MenuItem key={12+(item.lifeSpanTime/30/24)} value={12+(item.lifeSpanTime/30/24)}>1{t('message.common.select.year.extension')}</MenuItem>
                                        </Select>
                                        </FormControl>
                                        <Button className="apply_btn" variant="contained" onClick={()=>{applyClick(item.id)}}>{t('message.common.btn.apply')}</Button>
                                    </div>
                                    </TableCell>
                                    }
                                </TableRow>
                                )
                                })
                                )
                            })}
                                </TableBody>
                            </Table>
                            </TableContainer>
                            }
                        </Col>
                    </Row>
                </div>
                </CardContent>
            </MainCard>
        </Modal>
        </>
    )

}

export default EquipmentPartsReplaceLayer;